import { mapSecondsToTimeValue, mapTimeValueToSeconds } from './time-util';

const SKIP_CHECK_FILE_DURATION = 'Не проверять длительность файла.txt';
const MIN_DURATION_DIFF = 2;

export function validateFileDuration(file, request) {
    return new Promise((resolve, reject) => {
        if (!file || (!file.type.startsWith('audio/') && !file.type.startsWith('video/'))) {
            return resolve('Неверный тип файла.');
        }
        if (hasRequestSkipCheckFile(request)) {
            return resolve('Проверка длиетльности отключена');
        }
        const reqDurationSec = getRequestDuration(request);
        if (!reqDurationSec) {
            return reject(new Error('В заявке Не задано поле длительность.'));
        }

        const mediaElement = file.type.startsWith('video/')
            ? document.createElement('video')
            : document.createElement('audio');
        mediaElement.preload = 'metadata'; // Важно для быстрой загрузки метаданных
        const objectUrl = URL.createObjectURL(file);

        mediaElement.onloadedmetadata = function () {
            const fileDuration = mediaElement.duration;

            if (isNaN(fileDuration) || fileDuration === Infinity) {
                reject(new Error(`Не получается определить длительность файла.`));
            } else if (Math.abs(fileDuration - reqDurationSec) > MIN_DURATION_DIFF) {
                reject(
                    new Error(
                        `Длительность файла (${mapSecondsToTimeValue(fileDuration, true)}) не совпадает` +
                            ` со значением в заявке (${mapSecondsToTimeValue(reqDurationSec)}).` +
                            ` Обновите предварительно значение в заявке.`
                    )
                );
            } else {
                resolve(`Длительность в норме (${fileDuration}s).`);
            }

            URL.revokeObjectURL(objectUrl); // Освобождаем память
            document.body.removeChild(mediaElement); // Удаляем элемент
        };

        mediaElement.onerror = function () {
            reject(new Error('Ошибка при загрузке метаданных файла. Возможно файл не поддерживаемого типа.'));
            URL.revokeObjectURL(objectUrl);
            document.body.removeChild(mediaElement);
        };

        mediaElement.src = objectUrl;
        document.body.appendChild(mediaElement); // Добавляем элемент (невидимый), чтобы он начал загрузку
    });
}

function getRequestDuration(request) {
    if (!request) {
        return 0;
    }
    const timeField = request.nomination.dataFields.find((field) => field.code === 'time');
    if (timeField) {
        const timeFieldValue = request.fields[timeField.id] && request.fields[timeField.id].value;
        if (timeFieldValue) {
            return mapTimeValueToSeconds(timeFieldValue);
        }
    }
    return 0;
}

function hasRequestSkipCheckFile(request) {
    if (!request || !request.files) {
        return false;
    }
    return request.files.some(
        (file) => file.fileType.code === 'FONO' && file.filename && file.filename === SKIP_CHECK_FILE_DURATION
    );
}
